import { Typography } from '@customink/pigment-react';

import { spacing8 } from '@/utils/designTokens';

export const Delimiter = () => (
  <Typography display="inline-flex" marginX={spacing8}>
    {' | '}
  </Typography>
);
